import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Heart } from 'lucide-react';
import { businessInfo, images } from '../../data/mock';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Nutritional Therapy', path: '/nutritional-therapy' },
    { name: 'Detox Support', path: '/detox-support' },
    { name: 'Pure Renewal Protocol', path: '/pure-renewal-protocol' },
    { name: 'All Services', path: '/services' },
  ];

  const moreLinks = [
    { name: 'Orientation Classes', path: '/orientation' },
    { name: 'Classes & Events', path: '/classes' },
    { name: 'Contact Us', path: '/contact' },
  ];

  return (
    <footer className="bg-[#2C2F36] text-white">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src={images.logo} 
                alt="Serenity Natural Health & Wellness"
                className="h-24 w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Helping the sick recover by nourishing the body with abundant, high-quality nutrients. 
              Your path to natural wellness starts here.
            </p>
            <a 
              href={businessInfo.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gray-400 hover:text-[#6E9EB9] transition-colors"
            >
              <Facebook size={20} />
              Follow us on Facebook
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-medium mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-[#6E9EB9] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="text-lg font-serif font-medium mb-6">Explore</h4>
            <ul className="space-y-3">
              {moreLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-gray-400 hover:text-[#6E9EB9] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-serif font-medium mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-[#6E9EB9] transition-colors"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0" />
                  {businessInfo.phone}
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-[#6E9EB9] transition-colors"
                >
                  <Mail size={18} className="mt-0.5 flex-shrink-0" />
                  {businessInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span>{businessInfo.address}</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <Clock size={18} className="mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p>Mon, Wed-Fri: 9AM - 5PM</p>
                  <p>Tue: 9AM - 7PM</p>
                  <p>Sat: By Appointment</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
            <p>
              © {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
            </p>
            <p className="flex items-center gap-1">
              Made with <Heart size={14} className="text-[#D4A5A5]" /> in Gordon, Nebraska
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;